/**
 * Formats card number with spaces (e.g., "1234 5678 9012 3456")
 */
export function formatCardNumber(value: string): string {
  const cleaned = value.replace(/\s/g, "");
  const match = cleaned.match(/.{1,4}/g);
  return match ? match.join(" ") : cleaned;
}

/**
 * Formats expiry date as MM/YY
 */
export function formatExpiryDate(value: string): string {
  const cleaned = value.replace(/\D/g, "");
  if (cleaned.length >= 2) {
    return `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}`;
  }
  return cleaned;
}
